import React, { useEffect, useState } from 'react';
import { Modal } from '../../../components/common/Modal/Modal';
import { EditPanelButton } from '../../../components/elements';
import { GenericMap, IMarker } from '../../../components/utils/GenericMap';
import { useTranslate } from '../../../mixins/translate/translate';
import { MapDialogState } from './SurveyEditAoInspectieOverspanningenUnitAansluitkast';

export function MapDialog(props: {
    latitude?: number | undefined;
    longitude?: number | undefined;
    onClose(newValue?: { latitude: number; longitude: number }): void;
}) {
    const [state, setState] = useState<MapDialogState>({});
    const translate = useTranslate();

    const markers: IMarker[] = [];
    const markerLatitude = state.selectedLatitude ?? props.latitude;
    const markerLongitude = state.selectedLongitude ?? props.longitude;

    function mapClicked(longitude: number, latitude: number) {
        setState((s) => ({ ...s, selectedLatitude: latitude, selectedLongitude: longitude }));
    }

    useEffect(() => {
        if (props.latitude) {
            setState((s) => ({ ...s, initialLatitude: props.latitude, initialLongitude: props.longitude }));
        } else {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const crd = pos.coords;
                    setState((s) => ({ ...s, initialLatitude: crd.latitude, initialLongitude: crd.longitude }));
                },
                () => setState((s) => ({ ...s, initialLatitude: 52.359136, initialLongitude: 4.9053578 })),
                options,
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function save() {
        if (state.selectedLatitude && state.selectedLongitude) {
            props.onClose({ latitude: state.selectedLatitude, longitude: state.selectedLongitude });
        } else {
            props.onClose();
        }
    }

    if (!state.initialLatitude) {
        return null;
    }

    if (markerLatitude && markerLongitude) {
        markers.push({
            key: `${markerLatitude}_${markerLongitude}`,
            position: {
                lat: markerLatitude,
                lng: markerLongitude,
            },
            title: translate('common.selectedPoint'),
            color: '#6194d0',
        });
    }

    return (
        <Modal id="map-dialog" classNames="confirm-dialog" closeOnBackdropClick={true} onClose={() => props.onClose()}>
            <Modal.Content isScrollBarVisible={true} style={{ height: '650px', width: '800px' }}>
                <GenericMap
                    mapClicked={mapClicked}
                    markers={markers}
                    zoom={19}
                    isDroneNoFlyMapNlAvailable={false}
                    isPdokMapLayerAvailable
                    center={{
                        lat: state.initialLatitude ?? 52.359136,
                        lng: state.initialLongitude ?? 4.9053578,
                    }}
                />
            </Modal.Content>
            <Modal.Status>
                {translate('common.selectedPoint')}: {state.selectedLatitude} {state.selectedLongitude}
            </Modal.Status>
            <Modal.Actions>
                <EditPanelButton small={true} text={translate('common.cancel')} onClick={() => props.onClose()} />
                <EditPanelButton small={true} text={translate('common.save')} primary onClick={save} />
            </Modal.Actions>
        </Modal>
    );
}
